










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import ActionListApproveForm from '@/components/action_list/ActionListApproveForm.vue';

@Component({
  components: {
    Header,
    ActionListApproveForm,
    Footer,
  },
})
export default class ActionListApprove extends Vue {}
